import {Pipe, PipeTransform} from '@angular/core';
import * as moment from "moment";

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {

  transform(input: string | any, format: string): string {
    if (!input) return '';
    return moment(input, 'YYYY-MM-DD[T]HH[:]mm[:]ss[GMT]Z').format(format);
  }
}
